/* eslint-disable react/no-unused-state */
import React, { PropTypes } from 'react'
import Loading from 'components/Loading'
import Card from 'components/Card'
import Heading from 'components/Heading'
import Pagination from 'components/Pagination'
import { PersonalInfoList, PersonalInfoFilter } from './components'
import { getCurrentPageData } from 'utils/paging'

const styles = Object.assign(
  {},
  require('./AdminCentre.scss'),
  { table: require('components/Table/Table.scss') },
)

class AdminCentre extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    getPersonalInfos: PropTypes.func,
    openPartnerHierarchyForm: PropTypes.func.isRequired,
    openPartnerPlanStatusForm: PropTypes.func.isRequired,
    personalinfos: PropTypes.object,
    setCodeFilter: PropTypes.func,
    setLocationFilter: PropTypes.func,
    setSelectedPartner: PropTypes.func,
    setStatusFilter: PropTypes.func,
  }

  static defaultProps = {
    getPersonalInfos: null,
    setCodeFilter: null,
    setLocationFilter: null,
    setStatusFilter: null,
    setSelectedPartner: null,
    personalinfos: null,
  }

  constructor(props) {
    super(props)
    this.handleInitFilteredPersonalInfo = this.handleInitFilteredPersonalInfo.bind(this)
    this.handleChangeFilteredPersonalInfos = this.handleChangeFilteredPersonalInfos.bind(this)
    this.handleTextSearchTrigger = this.handleTextSearchTrigger.bind(this)
    this.handleLocationSearchTrigger = this.handleLocationSearchTrigger.bind(this)
    this.handleCodeSearchTrigger = this.handleCodeSearchTrigger.bind(this)
    // this.data = this.props.personalinfos.personalinfos
    this.state = {
      filteredPersonalInfos: [],
      isTextSearch: false,
      isLocationSearch: false,
      isCodeSearch: false,
      isInitialLoad: true,
      sort: {
        type: 'name',
        direction: 'asc',
      },
      currentPage: 0,
      selectedPartner: {},
    }
  }

  getPageRecords = (pageIndex) => {
    this.setState({ currentPage: pageIndex })
  }

  handleInitFilteredPersonalInfo() {
    this.setState({ filteredPersonalInfos: [] }, () => {
      this.setState({ isTextSearch: false })
      this.setState({ isLocationSearch: false })
      this.setState({ isCodeSearch: false })
      this.setState({ isInitialLoad: true })
      this.props.getPersonalInfos(this.props.currentUser.EmployeeId)
      sessionStorage.removeItem('SelectedPartner')
      sessionStorage.removeItem('SelectedPlan')
      sessionStorage.removeItem('AdminCentreFilterSelection')
    })
  }

  handleChangeFilteredPersonalInfos(filteredinfo) {
    // this.setState(() => ({filteredPersonalInfos:filteredinfo}))
    setTimeout(() => { this.setState({ filteredPersonalInfos: filteredinfo }) }, 500)
    this.setState({ filteredPersonalInfos: filteredinfo }, () => {})
    this.setState({ isInitialLoad: false })
  }

  handleTextSearchTrigger(isTextSearch) {
    this.setState({ isTextSearch })
  }

  handleLocationSearchTrigger(isLocationSearch) {
    this.setState({ isLocationSearch })
  }

  handleCodeSearchTrigger(isCodeSearch) {
    this.setState({ isCodeSearch })
  }

  /* handleSelectedPartner(partnerId, partnerName, partnerEmail, label) {
    const selectedPartner = {
      EmployeeId: partnerId,
      Name: partnerName,
      Email: partnerEmail,
      userPrincipalName: partnerEmail,
    }
    this.props.setSelectedPartner(selectedPartner)
    if (label === 'Plan status') {
      setTimeout(() => { this.props.openPartnerPlanStatusForm() }, 800)
    }
  } */

  render() {
    const {
      personalinfos, setCodeFilter, setLocationFilter, setStatusFilter, setSelectedPartner, openPartnerPlanStatusForm, openPartnerHierarchyForm,
    } = this.props
    if (personalinfos.isFetching) {
      return (<Loading pageLoading />)
    }

    /* TODO: paging variables start here */
    const currentData = (this.state.isTextSearch || this.state.isLocationSearch || this.state.isCodeSearch || !this.state.isInitialLoad)
      ? this.state.filteredPersonalInfos
      : personalinfos.personalinfos

    const paging = getCurrentPageData(this.state.currentPage, currentData)
    return (
      <section className={styles.section}>
        <PersonalInfoFilter
          filteredPersonalInfos={currentData}
          onChangeFilteredPersonalInfos={this.handleChangeFilteredPersonalInfos}
          onCodeSearchTrigger={this.handleCodeSearchTrigger}
          onInitFilteredPersonalInfo={this.handleInitFilteredPersonalInfo}
          onLocationSearchTrigger={this.handleLocationSearchTrigger}
          onTextSearchTrigger={this.handleTextSearchTrigger}
          personalinfos={personalinfos}
          setCodeFilter={setCodeFilter}
          setLocationFilter={setLocationFilter}
          setStatusFilter={setStatusFilter}
        />
        <Heading noTopPadding> <span className={styles.recordCount} />
        </Heading>
        <Card noPadding>
          {/* (this.state.isTextSearch || (this.state.filteredPersonalInfos  && this.state.filteredPersonalInfos.length > 0))
            ? <PersonalInfoList onChangeFilteredPersonalInfos={this.handleChangeFilteredPersonalInfos} personalinfos={this.state.filteredPersonalInfos} />
          : <PersonalInfoList onChangeFilteredPersonalInfos={this.handleChangeFilteredPersonalInfos} personalinfos={currentPageData} /> */}
          <PersonalInfoList
            currentUser={this.props.currentUser}
            // onSelectedPartner={this.handleSelectedPartner}
            onChangeFilteredPersonalInfos={this.handleChangeFilteredPersonalInfos}
            openPartnerHierarchyForm={openPartnerHierarchyForm}
            openPartnerPlanStatusForm={openPartnerPlanStatusForm}
            personalinfos={paging.currentPageData}
            setSelectedPartner={setSelectedPartner}
            unfilteredPersonalInfos={currentData}
          />
        </Card>
        <Pagination handleChange={this.getPageRecords} pageCount={paging.pageCount} />
      </section>
    )
  }
}

export default AdminCentre



// WEBPACK FOOTER //
// ./src/views/AdminCentre/AdminCentre.js